import React from "react";
import { connect } from "react-redux";

const FreeProductItem = ({
  imgUrl,
  text,
  desc,
  isButton = false,
  buttonClickHandler,
  productHandle,
  appStateData,
  merchantData,
}) => {
  let { shopDomain } = appStateData;
  let { merchant } = merchantData;

  return (
    <div className="freeproduct-item-container">
      <a
        href={`https://${shopDomain}/products/${productHandle}`}
        target="_parent"
        className="freeproduct-item-img"
      >
        <img src={imgUrl} alt="item-img" />
      </a>
      <div className="freeproduct-item-details-container">
        <div className="freeproduct-item-details">
          <div className="freeproduct-item-details-text">{text}</div>
          <p className="freeproduct-item-details-subtext">{desc}</p>
        </div>
        {isButton && (
          <button
            onClick={buttonClickHandler}
            className="freeproduct-item-button"
          >
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
              : "Redeem"}
          </button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FreeProductItem);
